// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 17-09-2025

const futureDemandReportTypes = {
	/***************** FETCH FUTURE DEMAND REPORT START *************** */
	FETCH_FUTURE_DEMAND_REPORT_START: 'fetch_future_demand_report_start',
	FETCH_FUTURE_DEMAND_REPORT_SUCCESS: 'fetch_future_demand_report_success',
	FETCH_FUTURE_DEMAND_REPORT_FAILURE: 'fetch_future_demand_report_failure',
	FETCH_FUTURE_DEMAND_REPORT_RESPONSE_RESET_START: 'fetch_future_demand_report_reset_start',
	FETCH_FUTURE_DEMAND_REPORT_RESPONSE_CHANGED: 'fetch_future_demand_report_reponse_changed',
	/***************** FETCH FUTURE DEMAND REPORT END *************** */
};
export default futureDemandReportTypes;
